import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { PackageSearch, LogOut } from "lucide-react";

export default function RoleShell({ title, accent = "brand", tabs, active, setActive, children, right }) {
  const { user, logout } = useAuth();
  const { t: tr } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col md:flex-row">
      {/* Sidebar */}
      <aside className="md:w-64 bg-slate-950 text-white md:min-h-screen flex md:flex-col md:sticky md:top-0 md:h-screen">
        <div className="p-5 flex items-center gap-2 border-b border-white/10">
          <div className="w-9 h-9 rounded-xl bg-brand flex items-center justify-center"><PackageSearch className="w-5 h-5 text-white" /></div>
          <div className="hidden md:block">
            <div className="font-display font-extrabold leading-none">Drivons<span className="text-brand">Market</span></div>
            <div className="text-[10px] uppercase tracking-widest text-slate-400 mt-1">{title}</div>
          </div>
        </div>
        <nav className="flex md:flex-col gap-1 p-2 md:p-3 overflow-x-auto no-scrollbar flex-1">
          {tabs.map((t) => (
            <button key={t.key} data-testid={`tab-${t.key}`} onClick={() => setActive(t.key)}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium whitespace-nowrap transition-colors ${active === t.key ? "bg-brand text-white" : "text-slate-300 hover:bg-white/10"}`}>
              <t.icon className="w-4 h-4" /><span className="hidden md:inline">{tr(`roles.${t.key}`, t.label)}</span>
            </button>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10 hidden md:block">
          <div className="text-xs text-slate-400 mb-2 truncate">{user?.name}</div>
          <Button data-testid="role-logout" variant="ghost" size="sm" onClick={() => { logout(); navigate("/"); }} className="w-full justify-start text-slate-300 hover:bg-white/10 gap-2"><LogOut className="w-4 h-4" /> {tr("nav.logout")}</Button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <header className="glass sticky top-0 z-30 border-b px-5 h-16 flex items-center justify-between">
          <h1 className="font-display font-bold text-lg capitalize">{tr(`roles.${active}`, tabs.find((x) => x.key === active)?.label)}</h1>
          <div className="flex items-center gap-3">
            <LanguageSwitcher />
            {right}
            <Button data-testid="role-logout-top" variant="ghost" size="icon" className="md:hidden" onClick={() => { logout(); navigate("/"); }}><LogOut className="w-4 h-4" /></Button>
          </div>
        </header>
        <div className="p-5 max-w-6xl mx-auto">{children}</div>
      </main>
    </div>
  );
}
